import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, UrlTree } from '@angular/router';

import { EventDetailsConfig } from '@frontend/sports/common/client-config-data-access';
import { RouterEventsService } from '@frontend/sports/common/core/utils/router-events';

import { EventDetailsModalService } from './event-details-modal.service';
import { EventDetailsResolver } from './event-details.resolver';

@Injectable({ providedIn: 'root' })
export class EventDetailsModalGuard implements CanActivate {
    constructor(
        private eventDetailsModalService: EventDetailsModalService,
        private eventDetailsConfig: EventDetailsConfig,
        private eventDetailsResolver: EventDetailsResolver,
        private routerEventsService: RouterEventsService,
    ) {}

    async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
        if (this.eventDetailsConfig.showInOverlay && !this.routerEventsService.isDirectLink) {
            const eventData = await this.eventDetailsResolver.modalResolve(route);
            this.eventDetailsModalService.openOrUpdateModal(eventData, route, this.routerEventsService.urlHistory);
            return false;
        }

        return true;
    }
}
